import React, { useState } from "react";
import {
  Button,
  CustomDatePicker,
  Modal,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { usePagination } from "../../../../hooks";

const UpcomingPayCycles = () => {
  const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
      );
  const [saveModal, setSaveModal] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [editedPayDates, setEditedPayDates] = useState({});

  // Make table data stateful to apply permanent updates
  const [tableData, setTableData] = useState([
    {
      id: 1,
      payCycle: "04/01/2025 - 04/30/2025",
      actualPayDate: "2025-05-12T00:00:00.000Z",
      payDate: "2025-05-12T00:00:00.000Z",
    },
    {
      id: 2,
      payCycle: "05/01/2025 - 05/31/2025",
      actualPayDate: "2025-05-12T00:00:00.000Z",
      payDate: "2025-05-12T00:00:00.000Z",
    },
    {
      id: 3,
      payCycle: "06/01/2025 - 06/30/2025",
      actualPayDate: "2025-06-12T00:00:00.000Z",
      payDate: "2025-06-12T00:00:00.000Z",
    },
  ]);

  const handleClickEdit = (id) => {
    setEditRowId((prev) => (prev === id ? null : id));
  };

  const handleDateChange = (id, newDate) => {
    setEditedPayDates((prev) => ({
      ...prev,
      [id]: newDate,
    }));
  };

  const handleConfirmSave = () => {
    const updatedDate = editedPayDates[editRowId];
    if (updatedDate) {
      setTableData((prevData) =>
        prevData.map((row) =>
          row.id === editRowId ? { ...row, payDate: updatedDate } : row
        )
      );
    }

    // Clean up
    setEditedPayDates((prev) => {
      const copy = { ...prev };
      delete copy[editRowId];
      return copy;
    });
    setEditRowId(null);
    setSaveModal(false);
  };

  const updateTableData = tableData.map((data) => ({
    ...data,
    payDate: editedPayDates[data.id] || data.payDate,
    edit: data.id === editRowId,
  }));

  const columns = [
    {
      key: "payCycle",
      label: "Pay Cycle",
    },
    {
      key: "actualPayDate",
      label: "Actual Pay Date",
      render: (row) => dateFormator(row.actualPayDate, "month-day-year"),
    },
    {
      key: "payDate",
      label: "Pay Date",
      render: (row) => (
        <div>
          {row.edit ? (
            <CustomDatePicker
              type="datepicker"
              size="xs"
              value={row.payDate}
              onChange={(newDate) => handleDateChange(row.id, newDate)}
              placeholder="Select PayDate"
              showDropdown={false}
            />
          ) : (
            dateFormator(row.payDate, "month-day-year")
          )}
        </div>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-1 cursor-pointer text-linkblue">
          <Button
            type="icon"
            variant="text"
            // icon={"edit_square"}
            icon={row.edit ? "save" : "edit_square"}
            color="black"
            size="sm"
            onClick={() => handleClickEdit(row.id)}
          />
          {row.edit && (
            <Button
              type="icon"
              //   icon="polygon"
              icon="play_arrow"
              size="xs"
              onClick={() => setSaveModal(true)}
            />
          )}
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(updateTableData, columns);

  return (
    <div>
      <TableAdv
        tableId={`payroll_salaryprofileconfiguration_upcomingpaycycles`}
        rows={mappedRows}
        columns={columns}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search:true
        }}
      />

      <Modal
        isOpen={saveModal}
        onClose={() => setSaveModal(false)}
        title="CONFIRM"
        width="max-w-2xl"
      >
        <div className="pl-4 gap-4 flex flex-col">
          <p>
            Are you sure you want to make pay period
            <span className="font-medium mx-1">
              {tableData.find((row) => row.id === editRowId)?.payCycle}
            </span>
            the current pay period?
          </p>
          <p>The action performed here cannot be reverted.</p>
          <p>If you wish to continue, click on ‘Yes’</p>
          <div className="flex gap-3 justify-end my-8">
            <Button
              title="No"
              variant="outlined"
              onClick={() => setSaveModal(false)}
            />
            <Button title="Yes" onClick={handleConfirmSave} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default UpcomingPayCycles;
